import { useEffect } from 'react';

// Small imperative SEO helper — sets <title>, meta tags and JSON-LD without external libs
export const useSEO = ({ title, description, canonical, image, jsonLd }) => {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    const ensureMeta = (attr, value, content) => {
      let el = document.head.querySelector(`meta[${attr}="${value}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, value); document.head.appendChild(el); }
      el.setAttribute('content', content);
      return el;
    };
    const ensureLink = (rel, href) => {
      let el = document.head.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement('link'); el.setAttribute('rel', rel); document.head.appendChild(el); }
      el.setAttribute('href', href);
      return el;
    };

    const created = [];
    if (description) created.push(ensureMeta('name', 'description', description));
    if (title) created.push(ensureMeta('property', 'og:title', title));
    if (description) created.push(ensureMeta('property', 'og:description', description));
    if (image) created.push(ensureMeta('property', 'og:image', image));
    created.push(ensureMeta('property', 'og:type', 'website'));
    created.push(ensureMeta('name', 'twitter:card', 'summary_large_image'));
    if (title) created.push(ensureMeta('name', 'twitter:title', title));
    if (description) created.push(ensureMeta('name', 'twitter:description', description));
    if (image) created.push(ensureMeta('name', 'twitter:image', image));
    if (canonical) ensureLink('canonical', canonical);

    // JSON-LD
    let scriptEl;
    if (jsonLd) {
      scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.textContent = JSON.stringify(jsonLd);
      scriptEl.setAttribute('data-utk-jsonld', '1');
      document.head.appendChild(scriptEl);
    }

    return () => {
      document.title = prevTitle;
      if (scriptEl && scriptEl.parentNode) scriptEl.parentNode.removeChild(scriptEl);
    };
  }, [title, description, canonical, image, JSON.stringify(jsonLd || {})]); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useSEO;
